document.addEventListener('DOMContentLoaded', function() {
    if (window.globalFAQItems && window.globalFAQItems.length > 0) {
        const flattenedFAQs = window.globalFAQItems.flat();

        const faqSchema = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": flattenedFAQs
        };

        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify(faqSchema);
        document.head.appendChild(script);
    }
});